module.exports = __webpack_public_path__ + "img/error.a6b1782d.svg";